import Spinner from './SpinnerWithErrorBoundary';

export default Spinner;